import { render, staticRenderFns } from "./LayoutSearch.vue?vue&type=template&id=400b640a"
import script from "./LayoutSearch.vue?vue&type=script&lang=js"
export * from "./LayoutSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports